/* unplugin-vue-components disabled */import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.to-fixed.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7d42ee2f"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "aggregate-daily-sales-report"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "mb-2"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "点位"), /*#__PURE__*/_createElementVNode("th", null, "电量"), /*#__PURE__*/_createElementVNode("th", null, "电费（元）")], -1);
});
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "4"
  }, "暂无数据", -1);
});
var _hoisted_7 = [_hoisted_6];
import hyRequest from '@/service';
import { DEVELOPMENT } from '@/config/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'EnergyDetail',
  setup: function setup(__props) {
    var route = useRoute();
    console.log('route.query=>', route.query);
    var query = {};
    if (_.eq(process.env.NODE_ENV, DEVELOPMENT)) {
      query = _.isEmpty(route.query) ? {
        date: '2010-10-15',
        type: 1,
        areaName: ''
      } : route.query;
    }
    var list = ref([]);
    hyRequest.post({
      url: '/electricMeter/electricAreaKeyDetails',
      data: _objectSpread(_objectSpread({}, query), {}, {
        isAgg: 'Y'
      })
    }).then(function (data) {
      console.log('data====>', data);
      list.value = data.list;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("table", _hoisted_3, [_hoisted_4, _unref(list).length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_unref(list), function (item, index) {
        return _openBlock(), _createElementBlock("tr", {
          key: index
        }, [_createElementVNode("td", null, _toDisplayString(item.variable), 1), _createElementVNode("td", null, _toDisplayString(item.elevalue.toFixed(2)), 1), _createElementVNode("td", null, _toDisplayString(item.electricFee.toFixed(2)), 1)]);
      }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_5, _hoisted_7))])])]);
    };
  }
});